import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw0003Handlers = [
  // 企画支援会社情報取得 /kymw00/getPlanSupportCompanyInfo
  http.post(
    PlessService.SERVICE.getPlanSupportCompanyInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getPlanSupportCompanyInfoResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),
];

const getPlanSupportCompanyInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        AssociatedCompanyId: '123456',
        AssociatedCompanyName: 'XXX関連会社',
        TradeStopDiv: '0',
        TradeStopName: '',
      },
      {
        AssociatedCompanyId: '123457',
        AssociatedCompanyName: 'YYY関連会社',
        TradeStopDiv: '1',
        TradeStopName: '中止',
      },
      {
        AssociatedCompanyId: '123458',
        AssociatedCompanyName: 'ZZZ関連会社',
        TradeStopDiv: '2',
        TradeStopName: '廃止',
      }
    ],
  },
};
